














import { Vue, Component, Watch } from 'vue-property-decorator'
import { mapGetters } from 'vuex'
import sparqlService from '../service/SparqlService'
import main from '../main'

@Component({
  components: { },
  computed: mapGetters([
    'ontology',
    'language'
  ])
})
export default class OntologyPane extends Vue {
  mounted () {
    var onto = this.$route.params.ontology
    var lang = this.$route.query.lang
    console.log('ontology from router:', onto, ' language:', lang)

    this.$nextTick(function () {
      if (lang) {
        main.store.commit('language', lang)
      }
      console.log('OntologyPane: mounted hook')
      main.store.commit('resetOntology')
      sparqlService.getOntologyAsync(onto)
    })
  }

  gotoConcept (concept:any) {
    sparqlService.gotoConcept(this.$router, concept.concept.id)
  }

  @Watch('language')
  watchLanguage () {
    var onto = this.$route.params.ontology
    sparqlService.getOntologyAsync(onto)
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/OntologyPane.vue